import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { QueryBuilder } from 'lib/http/QueryBuilder';
import { Models } from 'models/core';
import { MooringArticle } from 'models/mooring';
import { MooringArticleProduct } from 'models/mooring/MooringArticleProduct';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class MooringArticleProductService extends BaseApiService<MooringArticleProduct> {
  constructor(
    httpClient: AuthHttpClient,
    private client: NetlogHttpClient
  ) {
    super(httpClient, MooringArticleProduct);
  }

  private getUrl(path: string) {
    return `${MooringArticleProduct.ApiUrl}/${path}`;
  }

  async items(query?: { erpSystemId?: number }) {
    let url = this.getUrl('items');
    if (query) {
      new QueryBuilder({
        erpSystemId: query.erpSystemId,
      }).forUrl(url);
    }

    return await this.httpClient.exec<MooringArticleProduct[]>(url, { method: 'GET' });
  }

  async details(articleProductId: number) {
    return await this.client.get<MooringArticleProduct>({ url: this.getUrl(`${articleProductId}/details`) });
  }

  async article(articleProductId: number) {
    return await this.httpClient.exec<MooringArticle>(MooringArticleProduct.ApiUrl + `/${articleProductId}/article`, {
      method: 'GET',
    });
  }

  public async search(search: string) {
    const url = new QueryBuilder({ search }).forUrl(`${MooringArticleProduct.ApiUrl}/search`);
    return await this.client.get<MooringArticleProduct[]>({ url });
  }

  public async productSearch(searchString: string, erpSystemId: number) {
    return await this.httpClient.exec<Models.Product[]>(
      `${MooringArticleProduct.ApiUrl}/products/search?searchString=${searchString}&erpSystemId=${erpSystemId}`,
      {
        method: 'GET',
      }
    );
  }
}
